var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import { NEW_TOOLS_SECOND_COLUMNS } from '../constants';
export var TableMenu = (_temp = _class = function (_Component) {
  _inherits(TableMenu, _Component);

  function TableMenu() {
    _classCallCheck(this, TableMenu);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TableMenu.prepareLists = function prepareLists(items, newToolsColumns, hiddenMenuColumns) {
    // We need some specific columns specified in NEW_TOOLS_COLUMNS to be the first headers in the set.
    var headers = new Set(newToolsColumns.concat(items.filter(function (item) {
      return hiddenMenuColumns.indexOf(item.parentHeader) === -1;
    }).map(function (item) {
      return item.parentHeader;
    })));

    var tableColumns = {};
    headers.forEach(function (header) {
      tableColumns[header] = items.filter(function (item) {
        return item.parentHeader === header;
      });
    });
    return tableColumns;
  };

  TableMenu.prototype.render = function render() {
    var _props = this.props,
        items = _props.items,
        newToolsColumns = _props.newToolsColumns,
        hiddenMenuColumns = _props.hiddenMenuColumns;

    var rows = TableMenu.prepareLists(items, newToolsColumns, hiddenMenuColumns);
    var allNewToolsColumns = newToolsColumns.concat(NEW_TOOLS_SECOND_COLUMNS);
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'new-tools-container' },
        Object.keys(rows).filter(function (key) {
          return includes(newToolsColumns, key);
        }).map(function (key) {
          return React.createElement(
            'ul',
            { key: key },
            React.createElement(
              'li',
              { className: 'list-title' },
              key
            ),
            rows[key].map(function (row, index) {
              return React.createElement(
                'li',
                { key: index },
                React.createElement(
                  'a',
                  { href: row.href },
                  row.label
                )
              );
            })
          );
        })
      ),
      React.createElement(
        'div',
        { className: 'new-tools-container' },
        Object.keys(rows).filter(function (key) {
          return includes(NEW_TOOLS_SECOND_COLUMNS, key);
        }).map(function (key) {
          return React.createElement(
            'ul',
            { key: key },
            React.createElement(
              'li',
              { className: 'list-title' },
              key
            ),
            rows[key].map(function (row, index) {
              return React.createElement(
                'li',
                { key: index },
                React.createElement(
                  'a',
                  { href: row.href },
                  row.label
                )
              );
            })
          );
        })
      ),
      Object.keys(rows).filter(function (key) {
        return !includes(allNewToolsColumns, key);
      }).map(function (key) {
        return React.createElement(
          'ul',
          { key: key, className: 'legacy-tools' },
          React.createElement(
            'li',
            { className: 'list-title' },
            key
          ),
          rows[key].map(function (row, index) {
            return React.createElement(
              'li',
              { key: index },
              React.createElement(
                'a',
                { href: row.href },
                row.label
              )
            );
          })
        );
      })
    );
  };

  return TableMenu;
}(Component), _class.defaultProps = { // eslint-disable-line
  items: [],
  hiddenMenuColumns: ['Account Information', 'Getting Started'],
  newToolsColumns: []
}, _temp);

TableMenu.propTypes = process.env.NODE_ENV !== "production" ? { // eslint-disable-line
  items: PropTypes.arrayOf(PropTypes.shape({
    parentHeader: PropTypes.string,
    label: PropTypes.string,
    href: PropTypes.string,
    linkId: PropTypes.string
  })),
  hiddenMenuColumns: PropTypes.array,
  newToolsColumns: PropTypes.array
} : {};
export default TableMenu;